import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { ManualsOpenedConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "manuals-opened-details",
  templateUrl: "./manuals-opened-details.component.html",
  standalone: false,
})
export class ManualsOpenedDetailsComponent
  extends BaseDetailsLogic<ManualsOpenedConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, ManualsOpenedConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedMinOpened(): number {
    return this.config?.minOpened || 1;
  }

  set selectedMinOpened(value: number) {
    this.config.minOpened = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedNumberResults(): number {
    return this.config?.top || 1;
  }

  set selectedNumberResults(value: number) {
    this.config.top = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod:
        "Pick a time period to see which manuals were opened during that time. For example, you can look at manuals opened in the last week, month, or year. This helps you understand when people are using your manuals.",
      minOpened:
        "Set the minimum number of times a manual must be opened to appear in the list. For example, if you enter 5, you will only see manuals that were opened at least 5 times. This helps you focus on the most used manuals.",
      numberResults:
        "Set how many manuals you want to see in the list. For example, if you enter 10, you will see the top 10 most opened manuals. This helps you find out which manuals are the most popular.",
    };
  }
}
